import {LayerDef} from "./LayerDef";
import {Hill} from "./Hill";
import {HillLists, LayerDefBase} from "./LayerDefBase";
import {COLOURS} from "./Colours";
import {Style} from "ol/style";

export class WainwrightsLayerDef extends LayerDefBase implements LayerDef {
    private visitedStyle = LayerDefBase.buildStyle(6, COLOURS.MUNRO.VISITED);
    private unvisitedStyle = LayerDefBase.buildStyle(
        6,
        COLOURS.MUNRO.UNVISITED
    );

    getProgressElement(): HTMLDivElement {
        return document.getElementById("progress-wainwright") as HTMLDivElement;
    }

    getCountElement(): HTMLDivElement {
        return document.getElementById("count-wainwright") as HTMLDivElement;
    }

    protected getUnvisitedStyle(): Style {
        return this.unvisitedStyle;
    }

    protected getVisitedStyle(): Style {
        return this.visitedStyle;
    }

    protected getLayerHills(hills: HillLists): Hill[] {
        return hills.lakes.filter((h) => h.categories.includes("WAINWRIGHT"));
    }

    getName(): string {
        return "Wainwrights";
    }
}
